<template>
  <div>
    <!-- Header -->

    <div class="header" :class="onModal ? 'pt-lg-2' : 'py-5 py-lg-7 pt-lg-7'">
      <!--     <b-container>
        <div class="header-body text-center mb-7">
          <b-row class="justify-content-center">
            <b-col xl="5" lg="6" md="8" class="px-5">
              <h1 class="text-white">Recuperar senha</h1>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div> -->
    </div>

    <!-- Page content -->
    <b-container class="mt--8 pb-0" :fluid="onModal ? true : false">
      <b-row class="justify-content-center pt-5">
        <b-col :lg="onModal? '12' : '5'" md="7">
          <b-card no-body class="bg-light">
            <b-card-body class="" style="padding-left: 40px; padding-right: 40px;">
              <span class="w-100 d-block text-center">
                <img src="img/janoo-logo-v2-high-color.png" style="max-width: 280px; height: auto;" class="pt-4 pb-3 justify-content-center align-items-center display-flex" />
              </span>

              <div v-if="true" style="color: #3E3E3E;" class="mb-1 pt-3">
                <h3 class="pb-2">Adicionar nova senha</h3>
              </div>

              <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">

                  <small style="font-weight: 600; color: gray;">Código de recuperação</small>
                  <base-input id="rec-code" alternative class="mb-3" name="Código de recuperação" :rules="{ required: true, min: 6, max:6 }" prepend-icon=""
                    type="text" placeholder="Digite o código de recuperação" v-model="form.hashcode">
                  </base-input>

                  <small style="font-weight: 600; color: gray;">Nova senha</small>
                  <base-input id="input-senha-1" alternative class="mb-3" name="Senha" :rules="{ required: true, min: 1 }" prepend-icon="no no-lock"
                    type="password" placeholder="Digite sua senha" v-model="form.password">
                  </base-input>

                  <b-alert :show="showAlert" dismissible variant="danger">
                    <span class="alert-text">{{ errorText }}</span>
                  </b-alert>

                  <small style="font-weight: 600; color: gray;">
                    Confirmar nova senha
                  </small>

                  <base-input id="input-senha" alternative class="mb-3" name="Confirmar Senha" :rules="{ required: true, min: 1 }" prepend-icon="no no-lock"
                    type="password" placeholder="Confirmar senha" v-model="form.confirm_password">
                  </base-input>

                  <b-alert :show="showAlert" dismissible variant="danger">
                    <span class="alert-text">{{ errorText }}</span>
                  </b-alert>

                  <span v-if="verifyPasswords" class="text-danger">
                    * Senhas não coincidem
                  </span>

                  <div class="text-center">
                    <base-button type="primary" native-type="submit" :disabled="disableLoginButton || verifyPasswords" class="mt-4 btn-block">
                      Salvar nova senha
                    </base-button>
                  </div>

                  <b-row class="mt-3">
                    <div class="text-gray text-center w-100" :class="onModal ? '' : 'pb-5'">
                      <a href="/login" class="text-gray" style="font-size: 14px; text-decoration-line: underline;">
                        Voltar ao Login
                      </a>
                    </div>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import swal from "sweetalert2";

export default {
  name: 'ResetPassword',

  props: {
    onModal: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: { password: "", confirm_password: "", hashcode: "" },
      showAlert: false,
      errorText: "",
      loginButtonText: "Logar",
      disableLoginButton: false
    };
  },

  computed: {
    ...mapGetters('login', {
      resetPasswordMessage: 'getResetPasswordMessage',
      resetPasswordError: 'getResetPasswordError',
    }),

    verifyPasswords(){
      return this.form.password.length == 0 || this.form.confirm_password.length == 0 || this.form.confirm_password != this.form.password
    },
  },

  watch: {
    resetPasswordMessage(newValue, oldValue){
      if(newValue != undefined && newValue != null && newValue.length > 0){
        this.disableLoginButton = false
        this.showSwal('Sucesso!!', newValue, 'primary', 'success')
      }
    },

    resetPasswordError(newValue, oldValue){
      if(newValue != undefined && newValue != null && newValue.length > 0){
        this.disableLoginButton = false
        this.showSwal('Erro!!', newValue, 'primary', 'warning')
      }
    },

  },

  methods: {
    ...mapActions('login', [
      'resetPassword',
    ]),

    ...mapActions('auth', [
      'logoutRequest',
    ]),

    async onSubmit() {
      this.showAlert = false;
      this.loginButtonText = "Enviando...";
      await this.resetPassword(this.form)
        .then(() => {
          if(this.onModal){ this.$emit("closeResetPasswordModal") }
          this.$router.push({ name: 'userLogin', })
        })
    },

    showSwal(title, text, btn, icon) {
      swal.fire({
        title: title,
        html: text,
        buttonsStyling: false,
        confirmButtonClass: `btn btn-${btn}`
      });
    },

  },

  created() {
    console.log("########", process.env.NODE_ENV, " mode #######");
  },

  mounted() {
  },

};
</script>
